import { VATs } from "../../../redux/settingsSlice";
import store from "../../../redux/store";
import { jobsFinalSum, jobsFinalVat, sumWithVAT, vatString } from "../TableSums";

export default function buildJobs(jobs, showComplexity) {
    const jobsVat = store.getState().settings.vats[VATs.jobs];
    const showVat = jobsVat.active;
   
    const body = [ 
        [
            {
                text: 'Наименование работы',
                bold: true
            },
            {
                text: 'Норматив',
                alignment: 'center',
                bold: true
            },
            {
                text: 'Стоимость н/ч',
                alignment: 'center',
                bold: true
            },
            showComplexity && {
                text: 'Слож-ность',
                alignment: 'center',
                bold: true
            },
            showVat && {
                text: 'НДС',
                alignment: 'center',
                bold: true
            },
            {
                text: 'Сумма',
                alignment: 'right',
                bold: true
            },
        ].filter(Boolean),
     ];

    const createJobText = (job) => {
        if(job.repair_tips) return;
        const operationName = job.operation.operation_name !== '' ? ' - ' + job.operation.operation_name : '';
        const jobNote = job.other ? " (" + job.other + ")" : "";

        return job.detail.part_name + operationName + jobNote;
    };

    jobs.forEach((job) => {
        if(job.repair_tips) return;
        if (!job.detail.detailOnly) {
            const sum = Math.round(job.sdh_hour * job.hourPrice * job.difficulty * 100) / 100;
            const row = [
                {
                    text: createJobText(job),
                },
                {
                    text: Math.round(job.sdh_hour * (store.getState().settings.diffFlag === 0 ? job.difficulty : 1) * 100) / 100,
                    alignment: 'center'
                },
                {
                    text: Math.round(job.hourPrice * (store.getState().settings.diffFlag === 1 ? job.difficulty : 1) * 100) / 100,
                    alignment: 'center'
                },
                showComplexity && {
                    text: job.difficulty,
                    alignment: 'center'
                },
                showVat && {
                    text: vatString(jobsVat),
                    alignment: 'center'
                },
                {
                    text: sumWithVAT(sum, jobsVat).toFixed(2),
                    alignment: 'right'
                },
            ].filter(Boolean);

            body.push(row);
        }
    });

    const widths = ['*', 60, 65, showComplexity && 40, showVat && 40, 40].filter(Boolean);
    return [
        {
            text: 'Выполненные работы',
            alignment: 'center',
            style: 'subheader'
        },
        {
            layout: 'lightHorizontalLines',
            table: {
                headerRows: 1,
                widths: widths,
                body: body
            }
        },
        {
            columns: [
                {
                    width: '60%',
                    text: '',
                },
                {
                    width: '40%',
                    stack: [
                        {
                            columns: [
                                {
                                    width: '50%',
                                    text: 'Итого работ:'
                                },
                                {
                                    width: '50%',
                                    text: jobsFinalSum({ useVat: true }).toFixed(2) + ' руб.',
                                    bold: true,
                                    alignment: 'right'
                                }
                            ]
                        },
                        {
                            columns: [
                                {
                                    width: '50%',
                                    text: 'НДС:'
                                },
                                {
                                    width: '50%',
                                    text: jobsFinalVat().toFixed(2) + ' руб.',
                                    alignment: 'right'
                                }
                            ]
                        }
                    ],
                },
            ]
        }
    ];
}